module.exports = __webpack_public_path__ + "static/media/Community2.36d7d55c.png";